/** @jsxRuntime classic */
/** @jsx jsx */
import { Grid } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
// import { Cloudinary  } from '@cloudinary/url-gen';
// import { pad } from '@cloudinary/url-gen/actions/resize';
// import { color } from '@cloudinary/url-gen/qualifiers/background';
// import { compass } from '@cloudinary/url-gen/qualifiers/gravity';
// import { AdvancedImage } from '@cloudinary/react';
import * as React from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Cloudinary } from 'cloudinary-core';
const cl = new Cloudinary({ cloud_name: 'bottlebooks' });

type UrlOptions = Parameters<typeof cl.url>[1];

interface Props {
  floorId: 'parterre' | 'mezzanin';
  roomId?: string;
  [x: string]: unknown;
}

export default function FloorPlansSection({ floorId, roomId, ...rest }: Props) {
  return (
    <Gallery
      publicIds={[planPublicId(floorId), planPublicId(roomId)].filter(Boolean)}
      options={{ crop: 'pad', background: '#fff', gravity: 'center' }}
      width={640}
      sx={{
        gridTemplateColumns: '1fr 1fr',
        paddingX: 'gutter',
        paddingY: 3,
        textAlign: 'center',
      }}
      {...rest}
    />
  );

  // return (
  //   <Box
  //     sx={{
  //       display: 'grid',
  //       gap: 3,
  //       gridTemplateColumns: '1fr 1fr',
  //       paddingX: 'gutter',
  //       paddingY: 3,
  //       textAlign: 'center',
  //     }}
  //     {...rest}
  //   >
  //     <FloorPlan id={floorId} size="medium" />
  //     {roomId && (
  //       <RoomPlan
  //         sx={{
  //           overflow: 'hidden',
  //           position: 'relative',
  //           display: 'inline-block',
  //         }}
  //         roomId={roomId}
  //         sizes="min-width(1280px) 640px, 50vw"
  //         onClick={() => showIndex(1)}
  //       />
  //     )}
  //     {currentIndex == null ? null : (
  //       <GalleryLightbox
  //         sx={{ fontFamily: 'text', color: 'red' }}
  //         current={{
  //           full: { src: roomPlan(roomId, 1920, 1080, 'png')?.toURL() },
  //         }}
  //         onClose={() => showIndex(null)}
  //         onPrevious={() => showIndex(currentIndex - 1)}
  //         onNext={() => showIndex(currentIndex + 1)}
  //       />
  //     )}
  //   </Box>
  // );
}

function planPublicId(roomId: string) {
  if (roomId === 'geheime-ratstube') return null;
  if (roomId === 'trabantenstube') return null;
  if (roomId === 'erzherzog-karl-saal') return null;
  return `vievinum/plaene/${roomId}`;
}

interface GalleryProps {
  publicIds: string[];
  layout?: 'constrained' | 'fixed' | 'fluid';
  options?: UrlOptions;
  width?: number;
  [x: string]: unknown;
}

function Gallery({ publicIds, layout, options, width, ...rest }: GalleryProps) {
  const [index, showIndex] = React.useState<number | null>(null);

  return (
    <Grid {...rest}>
      {publicIds.map((publicId, index) => (
        <GalleryImage
          key={publicId}
          publicId={publicId}
          layout={layout}
          options={{ ...options, width }}
          alt=""
          onClick={() => showIndex(index)}
        />
      ))}
      {index != null && (
        <GalleryLightbox
          publicIds={publicIds}
          currentIndex={index}
          onClose={() => showIndex(null)}
          options={{ ...options }}
          onPrevious={() =>
            showIndex(
              (index) => (index + publicIds.length - 1) % publicIds.length
            )
          }
          onNext={() => showIndex((index) => (index + 1) % publicIds.length)}
        />
      )}
    </Grid>
  );
}

function GalleryImage({ publicId, layout, options, alt, ...rest }) {
  return (
    <img
      src={imageUrl(publicId, { format: 'png', ...options })}
      alt={alt}
      sx={{ objectFit: 'cover', maxWidth: '100%' }}
      {...rest}
    />
  );
}

function imageUrl(publicId: string | null, options: UrlOptions) {
  if (!publicId) return undefined;
  return cl.url(publicId, { secure: true, ...options });
}

// function RoomPlan({
//   roomId,
//   sizes,
//   ...rest
// }: {
//   roomId: string;
//   sizes?: string;
// }) {
//   if (roomId === 'geheime-ratstube') return null;
//   if (roomId === 'trabantenstube') return null;
//   if (roomId === 'erzherzog-karl-saal') return null;
//   const publicId = `vievinum/plaene/${roomId}`;

//   return (
//     <picture {...rest}>
//       <source
//         type="image/webp"
//         srcSet={cld
//           .image(`${publicId}`)
//           .resize(
//             pad(640, 480).gravity(compass('center')).background(color('white'))
//           )
//           .format('webp')
//           .toURL()}
//         sizes={sizes}
//       />
//       <AdvancedImage
//         cldImg={cld
//           .image(publicId)
//           .resize(
//             pad(640, 480).gravity(compass('center')).background(color('white'))
//           )
//           .format('png')}
//         sx={{ objectFit: 'cover', objectPosition: 'center', width: '100%' }}
//         sizes={sizes}
//       />
//     </picture>
//   );
// }

interface GalleryLightboxProps {
  publicIds: string[];
  options?: UrlOptions;
  currentIndex: number;
  onClose: () => void;
  onPrevious: () => void;
  onNext: () => void;
}
function GalleryLightbox({
  publicIds,
  options,
  currentIndex,
  onClose,
  onNext,
  onPrevious,
  ...rest
}: GalleryLightboxProps) {
  const currentId = publicIds[currentIndex];
  const nextId = publicIds[(currentIndex + 1) % publicIds.length];
  const previousId =
    publicIds[(currentIndex + publicIds.length - 1) % publicIds.length];
  const fullOptions = { format: 'png', ...options, width: 1920, height: 1080 };
  const thumbOptions = { format: 'png', ...options, width: 640 };
  return (
    <InnerLightbox
      sx={{
        '.ril-toolbar-left .ril-toolbar__item__child': {
          variant: 'title.small',
        },
        '.ril-caption': { variant: 'text.default' },
      }}
      mainSrc={imageUrl(currentId, fullOptions)}
      mainSrcThumbnail={imageUrl(currentId, thumbOptions)}
      nextSrc={imageUrl(nextId, fullOptions)}
      nextSrcThumbnail={imageUrl(nextId, thumbOptions)}
      prevSrc={imageUrl(previousId, fullOptions)}
      prevSrcThumbnail={imageUrl(previousId, thumbOptions)}
      onCloseRequest={onClose}
      onMoveNextRequest={onNext}
      onMovePrevRequest={onPrevious}
      {...rest}
    />
  );
}

/**
 * To pass the className into wrapperClassName we need to wrap the component once.
 */
function InnerLightbox({
  mainSrc,
  mainSrcThumbnail,
  nextSrc,
  nextSrcThumbnail,
  prevSrc,
  prevSrcThumbnail,
  className,
  ...rest
}: import('react-image-lightbox').ILightBoxProps & { className?: string }) {
  return (
    <Lightbox
      wrapperClassName={className}
      mainSrc={mainSrc}
      mainSrcThumbnail={mainSrcThumbnail}
      nextSrc={nextSrc}
      nextSrcThumbnail={nextSrcThumbnail}
      prevSrc={prevSrc}
      prevSrcThumbnail={prevSrcThumbnail}
      {...rest}
    />
  );
}
